import script from "./LookingForSection.vue?vue&type=script&setup=true&lang=js"
export * from "./LookingForSection.vue?vue&type=script&setup=true&lang=js"

import "./LookingForSection.vue?vue&type=style&index=0&id=3cb1b5ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cb1b5ca"]])

export default __exports__